import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from 'recharts';
import Icon from '../../../components/AppIcon';

const ConversionFunnel = ({ data }) => {
  const colors = ['#3B82F6', '#1FB5A5', '#10B981', '#8B5CF6', '#059669'];

  return (
    <div className="bg-white rounded-xl shadow-elevation-1 p-6">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-lg font-bold text-foreground mb-1">Conversion Funnel</h3>
          <p className="text-sm text-muted-foreground">Lead progression through sales stages</p>
        </div>
        <div className="w-10 h-10 bg-[#D1F5F0] rounded-lg flex items-center justify-center">
          <Icon name="Filter" size={20} className="text-[#1FB5A5]" />
        </div>
      </div>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={data} layout="vertical">
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis type="number" />
          <YAxis dataKey="stage" type="category" width={150} />
          <Tooltip 
            content={({ active, payload }) => {
              if (active && payload && payload?.length) {
                return (
                  <div className="bg-white p-3 rounded-lg shadow-lg border border-gray-200">
                    <p className="font-semibold text-foreground">{payload?.[0]?.payload?.stage}</p>
                    <p className="text-sm text-muted-foreground">Count: {payload?.[0]?.payload?.count}</p>
                    <p className="text-sm text-[#1FB5A5] font-medium">{payload?.[0]?.payload?.percentage}%</p>
                  </div>
                );
              }
              return null;
            }}
          />
          <Bar dataKey="count" radius={[0, 8, 8, 0]}>
            {data?.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={colors?.[index % colors?.length]} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
      <div className="mt-4 grid grid-cols-2 gap-4">
        {data?.map((stage, index) => (
          <div key={index} className="flex items-center gap-2">
            <div 
              className="w-3 h-3 rounded-full" 
              style={{ backgroundColor: colors?.[index % colors?.length] }}
            />
            <span className="text-xs text-muted-foreground">{stage?.stage}: {stage?.percentage}%</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ConversionFunnel;